import { BASE_URL } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  PATCH: 'VIBE_PATCH',
  PATCH_SUCCESS: 'VIBE_PATCH_SUCCESS',
  PATCH_FAILURE: 'VIBE_PATCH_FAILURE',
};

export const patch = actions.patch(() => `${BASE_URL}/notification/user-vibe/`, {
  PENDING: ACTIONS.PATCH,
  SUCCESS: ACTIONS.PATCH_SUCCESS,
  FAILURE: ACTIONS.PATCH_FAILURE,
});
